/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'

import { ImgSanity } from '@slite/components'

import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'
import { SMALL_BREAKPOINT } from '../../utils/breakpoints'

export const SectionSwitchedBenefits = ({
  title,
  data,
  background = 'moon-dust',
}: {
  title: string
  background?: string
  data: {
    title: string
    description: string
    imageUrl: string
    imageAlt: string
  }[]
}) => {
  return (
    <Section background={background}>
      <div className="grid-12">
        <div className="grid-span-10 grid-offset-1 text-align-center margin-bottom-48 padding-bottom-8">
          <WebsiteText variant="title" className="margin-bottom-40">
            {title}
          </WebsiteText>
        </div>
      </div>
      <div className="flexbox flexbox-column flexbox-row-gap-60">
        {data.map((d, index) => {
          const isEven = index % 2 === 0
          return (
            <div
              className="grid-12 grid-gap-40 grid-align-center"
              key={d.title}
            >
              <ImgSanity
                className="grid-span-6 radius-larger grid-span-12-small"
                alt={d.imageAlt}
                src={d.imageUrl}
                css={css`
                  @media screen and (min-width: ${SMALL_BREAKPOINT}px) {
                    order: ${isEven ? 2 : 1};
                  }
                `}
              />
              <div
                className="grid-span-6 grid-span-12-small"
                css={css`
                  @media screen and (min-width: ${SMALL_BREAKPOINT}px) {
                    order: ${isEven ? 1 : 2};
                  }
                `}
              >
                <h4 className="font-family-title font-size-4 margin-bottom-8 font-weight-medium">
                  {d.title}
                </h4>
                <WebsiteText variant="body-lg">{d.description}</WebsiteText>
              </div>
            </div>
          )
        })}
      </div>
    </Section>
  )
}
